export default "__VITE_ASSET__85b9750f__"